import {
  PaymentRecordDetailActionTypes,
  PaymentStatus,
  CollectionStatus,
  CreditCardType,
  PaymentMethodType
} from './Types';

export const GET_PAYMENT_RECORD_DETAIL: PaymentRecordDetailActionTypes = 'GET_PAYMENT_RECORD_DETAIL';
export const REQUEST_COLLECTION: PaymentRecordDetailActionTypes = 'REQUEST_COLLECTION';
export const RETRY_FAILED_PAYMENT: PaymentRecordDetailActionTypes = 'RETRY_FAILED_PAYMENT';
export const GET_PAYMENT_LIST: PaymentRecordDetailActionTypes = 'GET_PAYMENT_LIST';
export const GET_PAYMENT_DETAILS: PaymentRecordDetailActionTypes = 'GET_PAYMENT_DETAILS';
export const RIDIRECT_FROM_MEMBER: PaymentRecordDetailActionTypes = 'RIDIRECT_FROM_MEMBER';
export const REMOVE_RIDIRECT_FROM_MEMBER: PaymentRecordDetailActionTypes = 'REMOVE_RIDIRECT_FROM_MEMBER';
export const REMOVE_PAYMENT_DETAILS: PaymentRecordDetailActionTypes = 'REMOVE_PAYMENT_DETAILS';

export const SCHEDULED: PaymentStatus = 'SCHEDULED';
export const FAILED: PaymentStatus = 'FAILED';
export const SUCCEEDED: PaymentStatus = 'SUCCEEDED';
export const SUBMITTED: PaymentStatus = 'SUBMITTED';
export const RETURNED: PaymentStatus = 'RETURNED';
export const ALL_PAYMENT_STATUS: Array<PaymentStatus> = [SCHEDULED, SUBMITTED, SUCCEEDED, FAILED, RETURNED];

export const REQUESTED: CollectionStatus = 'REQUESTED';
export const IN_PROGRESS: CollectionStatus = 'IN_PROGRESS';
export const CLOSED: CollectionStatus = 'CLOSED';
export const NOT_REQUESTED: CollectionStatus = 'NOT_REQUESTED';
export const COLLECTED: CollectionStatus = 'COLLECTED';
export const ALL_COLLECTION_STATUS: CollectionStatus[] = [REQUESTED, IN_PROGRESS, CLOSED, NOT_REQUESTED, COLLECTED];

export const NONE: CreditCardType = 'NONE';
export const VISA: CreditCardType = 'VISA';
export const MASTERCARD: CreditCardType = 'MASTERCARD';
export const AMEX: CreditCardType = 'AMEX';

export const CREDIT_CARD_LENGTH = 16;
export const AMEX_LENGTH = 15;
export const MAX_BANK_ACCOUNT_LENGTH = 18;
export const FINANCIAL_INSTITUTION_LENGTH = 3;
export const TRANSIT_NUMBER_LENGTH = 5;

export const DEFAULT_PAYMENT_SCHEDULED = 0;

export const CASH: PaymentMethodType = 'CASH';
export const VOIDCHEQUE: PaymentMethodType = 'VOIDCHEQUE';
export const CREDITCARD: PaymentMethodType = 'CREDITCARD';
export const PAYMENT_METHOD_TYPES: PaymentMethodType[] = [CASH, VOIDCHEQUE, CREDITCARD];



// WEBPACK FOOTER //
// ./src/payments/Constants.tsx